/**
 * redux root reducer
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import { combineReducers } from 'redux';
import navigationReducer from './navigation/reducer';
import editingReducer from './editing/reducer';
import messageReducer from "./message/reducer";
import listingReducer from "./listing/reducer";
import typesReducer from "./types/reducer";
import viewReducer from "./view/reducer";
import activityReducer from "./activity/reducer";
import authorizationReducer from "./authorization/reducer";
import cboxReducer from "./cbox/reducer";
import testingReducer from "./testing/reducer";
import configurationReducer from "./configuration/reducer";
import menuReducer from "./menu/reducer";


/** inject a reducer with some other reducer, which is executed first
 *
 * @param reducer   reducer, which gets tweaked
 * @returns {*}     a new reducer including tweaking
 *
 * @author Jens Gruschel
 */
function tweakReducer(reducer)
{
    return (state, action) => {

        if(state.testing && state.testing.active) {
            return reducer(state, action);
        }
        else {
            if (state.configuration && state.configuration.active.logReduxActions) {
                console.log("action:", action.type, action);
            }
            const newState = reducer(state, action);
            if (state.configuration && state.configuration.active.logReduxState) {
                console.log("state:", newState);
            }
            return navigationReducer(newState, action);
        }
    }
}


const rootReducer = tweakReducer(combineReducers({
    editing: editingReducer,
    listing: listingReducer,
    types: typesReducer,
    messages: messageReducer,
    view: viewReducer,
    activity: activityReducer,
    authorization: authorizationReducer,
    cbox: cboxReducer,
    testing: testingReducer,
    configuration: configurationReducer,
    menu: menuReducer
}));

export default rootReducer